import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { LAYOUTS } from '../lib/constants'
import { Bar, Divider, Group, Spacer } from '../styles/toolbar'

export default function Toolbar({
  layout,
  txt,
  onLayoutChange,
  onFullscreen,
  onStopAll,
  onFilter,
}) {
  return (
    <Bar>
      <Button size="small" icon="filter" onClick={onFilter}>
        {txt.filter}
      </Button>

      <Divider />

      <Button size="small" icon="stop" onClick={onStopAll}>
        {txt.stop}
      </Button>

      <Spacer />

      <Button size="small" icon="fullscreen" onClick={onFullscreen}>
        {txt.fullscreen}
      </Button>

      <Group>
        {LAYOUTS.map(n => (
          <Button
            key={n}
            size="small"
            type={layout === n ? 'primary' : 'default'}
            onClick={() => onLayoutChange(n)}
          >
            {n}
          </Button>
        ))}
      </Group>
    </Bar>
  )
}

Toolbar.propTypes = {
  layout: PropTypes.number.isRequired,
  txt: PropTypes.object.isRequired,
  onLayoutChange: PropTypes.func.isRequired,
  onFullscreen: PropTypes.func.isRequired,
  onStopAll: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
}
